import { injectable } from '~/container'
import { langFallback$Fetch, langFallbackFetch } from '~/lang/utils/langfetch'
import { ImageRepository } from '../../domain/repositories/ImageRepository'
import { Image } from '../../domain/types'
import { FetchFilestackImageRepository } from './FetchFilestackImageRepository'

@injectable()
export class FetchImageRepository
  extends FetchFilestackImageRepository
  implements ImageRepository
{
  constructor(campsiteSlug: string, token: string, langCode: string) {
    super(campsiteSlug, token, langCode)
  }

  async getAllImages(): Promise<Image[]> {
    if (!this.token) throw new Error('Token is required to list review photos')
    const url = `/_/endpoints/pitchupphotos/review-photos/${this.token}/`
    const response = await langFallbackFetch(this.langCode, url)
    if (response.status === 404) {
      return []
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Django API response structure
    const data = await response.json()
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access -- Django API response structure
    return data.review_photos
  }

  async readOneById(imageId: string): Promise<Image> {
    if (!this.token) throw new Error('Token is required to get photo status')
    const url = `/_/endpoints/pitchupphotos/${imageId}/status/${this.token}/`
    return await langFallback$Fetch(this.langCode, url)
  }

  async delete(image: Image): Promise<void> {
    if (!this.token) throw new Error('Token is required to delete a photo')
    const url = `/_/endpoints/pitchupphotos/${image.id}/delete/${this.token}/`
    return await langFallback$Fetch(this.langCode, url, { method: 'POST' })
  }

  async update(image: Image): Promise<void> {
    if (!this.token) throw new Error('Token is required to update a photo')
    const url = `/_/endpoints/pitchupphotos/${image.id}/update/${this.token}/`
    const formData = new FormData()
    formData.append('title', image.caption)
    return await langFallback$Fetch(this.langCode, url, {
      method: 'POST',
      body: formData,
      mode: 'cors',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
  }
}
